﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getHaulier, getHauliers, saveHaulier, deleteHaulier } from "@/api/Maintainers/hauliers";

const key = "hauliers";

export function useHaulier(selected) {
	return useQuery(["hauliers", selected], () => selected && getHaulier({ slug: selected }));
}

export function useHauliersPaginate(params) {
	return useQuery([key, params], () => getHauliers(params));
}

export function useMutateHaulier(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveHaulier, {
		onSuccess: (response) => {
			const hauliers = _.omit(response, "detail");
			const haulier = _.omit(response, "hauliers");

			queryClient.setQueryData([key, String(haulier.detail.id)], haulier);
			queryClient.setQueryData([key, params], hauliers);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/configuracion/transportistas");
		},
	});
}

export function useMutateDeleteHaulier(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteHaulier, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}
